import React, { useContext, useMemo } from 'react';
import loadable from '@loadable/component';
import classNames from 'classnames';
import LazyLoad from '../../LazyLoad';
import RoundButton from '../../RoundButton';
import { Context } from '../../../context/AppContext';
import smoothScroll from '../../../utils/smoothScroll';
import Static from '../../Maps/Static';

import './styles.css';

const B2bLocation = loadable(() => import('../B2bLocation'), {
  ssr: false,
});

const About = ({
  description,
  location,
  state,
  address,
  geo,
  zoom = 5,
  title = `Find out more about ${location}`,
  b2bStyle,
}) => {
  const {
    media: { mobile },
  } = useContext(Context);

  const noDescriptionB2bStyle = useMemo(
    () => (mobile ? 'vertical' : 'horizontal'),
    [mobile]
  );

  if ((geo && geo !== '0.0,0.0') || address || description)
    return (
      <div
        className={classNames('Landing__About__root', {
          [`Landing__About__root--${b2bStyle}`]: b2bStyle,
        })}
      >
        <div>
          <h2 className="Landing__About__title">{title}</h2>

          <div className="Landing__About__body">
            {((geo && geo !== '0.0,0.0') || address) && (
              <LazyLoad className="Landing__About__mapWrapper">
                <Static
                  className={classNames('Landing__About__map', {
                    'Landing__About__map--noDescription': !description,
                  })}
                  center={geo && geo !== '0.0,0.0' ? geo : address}
                  width={description ? 372 : 900}
                  height={description ? 372 : 300}
                  zoom={zoom}
                />
              </LazyLoad>
            )}
            {description && (
              <div className="Landing__About__description">
                <div className="Landing__About__descriptionWrapper">
                  <p
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html:
                        description.slice(0, 745).trim() +
                        (description.length > 745 ? '...' : ''),
                    }}
                  />
                  {description.length > 745 ? (
                    <button
                      href="#readMore"
                      className="Landing__About__readMore"
                      onClick={() =>
                        smoothScroll(
                          document.querySelector('.About__ReadMore__root'),
                          66
                        )
                      }
                    >
                      Read more
                    </button>
                  ) : (
                    ''
                  )}
                </div>
                {((geo && geo !== '0.0,0.0') || address) && (
                  <RoundButton
                    theme="outlineBlue"
                    tag="a"
                    className="Landing__About__viewMap"
                    hoverIcon="icon-generalarrowesmall"
                    target="_target"
                    rel="noopener noreferrer nofollow"
                    href={`https://www.google.com/maps?q=${geo ||
                      encodeURIComponent(address)}`}
                  >
                    View on Map
                  </RoundButton>
                )}
              </div>
            )}
          </div>
        </div>
        {state && location && (
          <B2bLocation location={location} state={state} b2bStyle={b2bStyle} />
        )}
      </div>
    );
  if (state && location)
    return (
      <div
        className={classNames(
          'Landing__About__root Landing__About__root--noDescription',
          {
            [`Landing__About__root--${noDescriptionB2bStyle}`]: noDescriptionB2bStyle,
          }
        )}
      >
        <B2bLocation
          location={location}
          state={state}
          b2bStyle={noDescriptionB2bStyle}
        />
      </div>
    );
  return '';
};

export default About;
